import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomLockBadge = ({ size = 48, props }: Props): JSX.Element => {
    return (
        <SvgIcon {...props} style={{ width: size, height: size }} viewBox={`0 0 ${size} ${size}`}>
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                fill={'none'}
                xmlns={'http://www.w3.org/2000/svg'}
            >
                <path
                    d={
                        'M2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24Z'
                    }
                    stroke={'#00D991'}
                    strokeWidth={'4'}
                />
                <path
                    d={
                        'M31 19.3334H29.8333V17C29.8333 13.78 27.22 11.1667 24 11.1667C20.78 11.1667 18.1666 13.78 18.1666 17V19.3334H17C15.7166 19.3334 14.6666 20.3834 14.6666 21.6667V33.3334C14.6666 34.6167 15.7166 35.6667 17 35.6667H31C32.2833 35.6667 33.3333 34.6167 33.3333 33.3334V21.6667C33.3333 20.3834 32.2833 19.3334 31 19.3334ZM20.5 17C20.5 15.0634 22.0633 13.5 24 13.5C25.9366 13.5 27.5 15.0634 27.5 17V19.3334H20.5V17ZM31 33.3334H17V21.6667H31V33.3334ZM24 29.8334C25.2833 29.8334 26.3333 28.7834 26.3333 27.5C26.3333 26.2167 25.2833 25.1667 24 25.1667C22.7166 25.1667 21.6666 26.2167 21.6666 27.5C21.6666 28.7834 22.7166 29.8334 24 29.8334Z'
                    }
                    fill={'black'}
                    fillOpacity={'0.9'}
                />
            </svg>
        </SvgIcon>
    );
};

export default CustomLockBadge;
